import { ShieldCheck, BookOpen, Siren } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { ChatPanel } from "@/components/sparkle/ChatPanel";
import { useSparkle } from "@/components/sparkle/useSparkle";
import { ToothMascot } from "@/components/site/ToothMascot";

const POINTS = [
  { icon: BookOpen, t: "Guideline-based", d: "Answers follow pediatric dental guidelines (AAPD, ADA, ISPPD, WHO)." },
  { icon: ShieldCheck, t: "Remembers you", d: "Sign in and Sparkle keeps your chat history and your child's details." },
  { icon: Siren, t: "Knows when to call", d: "For swelling, injury or severe pain, Sparkle tells you to call us right away." },
];

export default function AskSparkle() {
  const chat = useSparkle();
  return (
    <div data-testid="ask-sparkle-page">
      <PageHeader eyebrow="Ask Sparkle" title="Your 24/7 kids' dental helper" text="Clear, practical answers about teething, brushing, cavities, habits and emergencies." />
      <div className="mx-auto grid max-w-7xl gap-6 px-4 py-8 sm:px-6 sm:py-12 lg:grid-cols-[1fr_2.2fr] lg:gap-8 lg:px-8">
        <div className="order-2 grid gap-3 sm:grid-cols-3 lg:order-1 lg:grid-cols-1 lg:content-start lg:gap-4">
          {POINTS.map((p) => (
            <div key={p.t} className="rounded-2xl border border-slate-200 bg-white p-5">
              <p.icon className="h-6 w-6 text-teal-600" />
              <p className="font-display mt-2 text-lg font-semibold text-slate-800">{p.t}</p>
              <p className="text-sm text-slate-600">{p.d}</p>
            </div>
          ))}
        </div>
        <div className="order-1 h-[78vh] min-h-[480px] overflow-hidden rounded-[1.5rem] border-2 border-teal-100 bg-[#f0fdfa] shadow-xl sm:rounded-[2rem] lg:order-2 lg:h-[760px]" data-testid="ask-sparkle-chat">
          <div className="flex items-center gap-3 bg-teal-600 px-5 py-4 text-white">
            <ToothMascot className="h-12 w-12 rounded-full bg-white p-1" />
            <div><p className="font-display text-xl font-semibold">Sparkle</p><p className="flex items-center gap-1.5 text-xs text-teal-100"><span className="h-2 w-2 rounded-full bg-lime-300" />Online · answers in seconds</p></div>
          </div>
          <div className="h-[calc(100%-80px)]"><ChatPanel chat={chat} /></div>
        </div>
      </div>
    </div>
  );
}
